module.exports = __webpack_public_path__ + "img/4cc3293eabffc59444562c8c9c954e20.a71db6e7.png";